import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import HttpBackend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import ru from "./locales/ru.json";
import en from "./locales/en.json";

i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
            fallbackLng: "ru",
            supportedLngs: ["ru", "en"],
            defaultNS: "translation",
            debug: true,
            interpolation: { escapeValue: false },
            resources: {
                en: {
                    translation: en,
                },
                ru: {
                    translation: ru,
                }
            },
    });

export default i18n;
